import { Link } from "react-router-dom"
import React from "./Services.css"
import Pipes from "../../images/pipes2.jpg"

const Services = () => {
  return (
    <div className="services" id="services">
      <div className="servicesContainer">
        <div className="singleService">
          <img src="https://www.wvi.org/sites/default/files/styles/medium_landscape/public/D485-0619-252_526528.JPG?itok=ylIkEInX" alt="" className="servicesImage" />
          <hr />
          <div className="servicesBottom">
            <p className="servicesName">Borehole Drilling</p>
            <Link to="/services/1"><button className="learn">Learn More</button></Link>
          </div>
        </div>
        <div className="singleService">
          <img src={Pipes} alt="" className="servicesImage" />
          <hr />
          <div className="servicesBottom">
            <p className="servicesName">General Plumbing</p>
            <Link to="/services/2"><button className="learn">Learn More</button></Link>
          </div>
        </div>
        <div className="singleService">
          <img src="https://i.pinimg.com/originals/46/f9/54/46f9548281a19daad08ea0e32f1bab0e.png" alt="" className="servicesImage" />
          <hr />
          <div className="servicesBottom">
            <p className="servicesName">Tank Elevation</p>
            <Link to="/services/3"><button className="learn">Learn More</button></Link>
          </div>
        </div>
        <div className="singleService">
          <img src="https://thegardenmen.com.au/wp-content/uploads/2021/10/What-is-Drip-Irrigation.jpg" alt="" className="servicesImage" />
          <hr />
          <div className="servicesBottom">
            <p className="servicesName">Irrigation</p>
            <Link to="/services/4"><button className="learn">Learn More</button></Link>
          </div>
        </div>
        <div className="singleService">
          <img src="https://www.damliners.co.ke/images/3.jpg" alt="" className="servicesImage" />
          <hr />
          <div className="servicesBottom">
            <p className="servicesName">Damliners</p>
            <Link to="/services/5"><button className="learn">Learn More</button></Link>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Services